function PriceComponent($http, AppConstants) {
	'ngInject';

	const service = {
		fetchAllPrices: fetchAllPrices,
		fetchPrices: fetchPrices,
		getPaginationInfo: getPaginationInfo,
		getAllPrices: getAllPrices,
		getPrices: getPrices,
		updatePrice: updatePrice,
		deletePrice: deletePrice,
		cleanPrices: cleanPrices
	};

	let allPrices = [];
	let prices = [];
	// Information for pagination, current_page, total(count of items), and per_page(items on page)
	const paginationInfo = {};
	let constLineId = null;
	return service;

	function cleanPrices() {
		prices = [];
	}

	/**
	 * Return all prices (price of sub line) from the Line
	 *
	 * @param lineId
	 * @param page
	 * @param sort
	 * @returns {*}
	 */
	function fetchAllPrices(lineId = null, sort = '-id', numerous = 1) {
		let paramsForRequest = {};
		// If lineId is null, it means that method 'fetchAllPrices' was called from infinite scroll
		if (lineId === null) {
			paramsForRequest = {
				page: getPaginationInfo().page + 1,
				sort,
				'per_page': AppConstants.perPage + 5,
				'line_id': constLineId,
				'is_numerous': numerous
			};
		} else {
			paramsForRequest = {
				page: 1,
				sort,
				'per_page': AppConstants.perPage + 5,
				'line_id': lineId,
				'is_numerous': numerous
			};
			constLineId = lineId;
		}

		// Make request to api if request page is 1 or last page is bigger than current page
		if (getPaginationInfo().last_page > getPaginationInfo().page || paramsForRequest.page === 1) {
			return $http.get(`${AppConstants.apiUrl}/prices`, {
				'params': paramsForRequest
			})
				.then(setAllPrices)
				.catch(failedRequest);
		} else {
			return false;
		}
	}

	/**
	 * Return prices only for sub lines, between two selected stations
	 *
	 * @param lineId
	 * @param fromStationId
	 * @param toStationId
	 * @returns {*}
	 */
	function fetchPrices(lineId = null, fromStationId = null, toStationId = null, numerous = 0) {
		return $http.get(`${AppConstants.apiUrl}/prices`, {
			'params': {
				'line_id': lineId,
				'from_station_id': fromStationId,
				'to_station_id': toStationId,
				'is_numerous': numerous
			}
		})
			.then(setPrices)
			.catch(failedRequest);
	}

	function updatePrice(newPrices) {
		return $http.put(`${AppConstants.apiUrl}/prices`, {
			'prices': newPrices
		})
			.then(successRequest)
			.catch(failedRequest);
	}

	function deletePrice(id) {
		return $http.delete(`${AppConstants.apiUrl}/prices/${id}`)
			.then(successRequest)
			.catch(failedRequest);
	}

	function setPrices(response) {
		prices = response.data.data;
		return prices;
	}

	function setAllPrices(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		paginationInfo.last_page = response.data.last_page;

		// If current page are bigger than 1, this means that the request is from infinite scroll
		if (response.data.current_page > 1) {
			response.data.data.forEach(function (value) {
				allPrices.push(value);
			});
		} else {
			allPrices = response.data.data;
		}

		return allPrices;
	}

	function getAllPrices() {
		return allPrices;
	}

	function getPrices() {
		return prices;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}

}
export default PriceComponent;



/** WEBPACK FOOTER **
 ** ./client/components/price/price.service.js
 **/